module.exports = __webpack_public_path__ + "static/img/topcontent.e96cd3ff.png";